import { useProductDataModel } from "@made-people/grease-product";
import { WithVariantsProductDeliveryStatus } from "./with-variants-product-delivery-status";

export const MMProductDeliveryStatus = () => {
  const productModel = useProductDataModel();

  if (productModel === "simple") {
    // Not supported in drawer.
    return null;
  } else if (productModel === "with_variants") {
    return <WithVariantsProductDeliveryStatus />;
  }

  return null;
};
